import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import historyThreeTrainersData from '../data/HistoryThree';
import './HistoryThree.css';

const HistoryThreeTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(historyThreeTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('✊ Revolutionary Spirit/Freedom Fighter selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/history-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/history-train-categories');
    };

    return (
        <div className="history-trainers-container">
            <div className="history-animated-background freedom-stance"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="history-trainers-header">
                <div className="header-content">
                    <h1>Revolutionary Spirits & Freedom Fighters</h1>
                    <p>Train with legendary rebels, warriors, and liberators who fought for freedom</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Revolutionary History</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="history-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="history-trainer-card floating-rebellion-element liberation-spark revolutionary-pulse"
                        onClick={() => handleTrainerSelect(trainer)}
                        data-character={trainer.id}
                        style={{
                            '--history-primary-color': trainer.color,
                            '--history-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Character-specific accent icons */}
                        {trainer.id === 'spartacus' && <div className="chains-accent"></div>}
                        {trainer.id === 'boudica' && <div className="sword-accent"></div>}
                        {trainer.id === 'king-leonidas' && <div className="sword-accent"></div>}
                        {trainer.id === 'theodore-roosevelt' && <div className="star-accent"></div>}
                        {trainer.id === 'che-guevara' && <div className="fist-accent"></div>}
                        {trainer.id === 'rasputin' && <div className="chains-accent"></div>}

                        {/* Trainer Image */}
                        <div className="history-trainer-image-section">
                            <div
                                className="history-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="revolutionary-flame-effect"></div>
                                <div className="experience-badge history-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="history-trainer-info-section chain-texture">
                            <h3 className="history-trainer-name">{trainer.name}</h3>
                            <p className="history-trainer-specialization">{trainer.specialization}</p>
                            <p className="history-trainer-description">{trainer.intro}</p>

                            <div className="history-trainer-details">
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">⚔️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">✊</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Revolutionary Divider */}
            <div className="revolutionary-divider"></div>

            {/* Footer */}
            <div className="history-trainers-footer battle-pattern">
                <div className="history-info">
                    <h3>Revolutionary Spirits & Freedom Fighters Philosophy</h3>
                    <div className="history-benefits-grid">
                        <div className="history-benefit-item">
                            <div className="benefit-icon">⛓️</div>
                            <div>
                                <strong>Chain Breaking Gladiator Power</strong>
                                <p>Life-or-death arena conditioning that transforms oppression into explosive liberation strength</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🔥</div>
                            <div>
                                <strong>Celtic Vengeance Warfare</strong>
                                <p>Maternal fury channeled into city-burning power that unites tribes against imperial occupation</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🛡️</div>
                            <div>
                                <strong>Spartan Last Stand Defense</strong>
                                <p>Elite warrior conditioning that chooses beautiful death over shameful surrender</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🦬</div>
                            <div>
                                <strong>Strenuous Life Presidential Vigor</strong>
                                <p>Trust-busting energy that charges up mountains and preserves wilderness for future generations</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🌟</div>
                            <div>
                                <strong>Guerrilla Revolutionary Mobility</strong>
                                <p>Jungle warfare conditioning that defeats regular armies through movement and unbreakable conviction</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🔮</div>
                            <div>
                                <strong>Mystical Supernatural Endurance</strong>
                                <p>Mad monk conditioning that survives poison, bullets, and drowning while toppling royal dynasties</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryThreeTrainers;